export const SUPPORTED_LANGUAGES = ['en', 'da'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

export const LANGUAGE_STORAGE_KEY = 'keybox-portal.language';

export function isSupportedLanguage(value: string | null | undefined): value is SupportedLanguage {
  return SUPPORTED_LANGUAGES.includes(value as SupportedLanguage);
}

/** Stored choice first, then the browser preferences, then English. */
export function resolveInitialLanguage(): SupportedLanguage {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (isSupportedLanguage(stored)) {
    return stored;
  }

  const preferred = (navigator.languages ?? [navigator.language])
    .map((tag) => tag?.split('-')[0]?.toLowerCase())
    .find(isSupportedLanguage);

  return preferred ?? DEFAULT_LANGUAGE;
}
